import { cn } from '@latitude/token-utils';

import type { SVGProps } from '../../types';

export const DisputeSubmittedIllustration = (props: SVGProps) => {
  const {
    title = 'DisputeSubmittedIllustration',
    className,
    ...restProps
  } = props;

  return (
    <svg
      className={cn('text-color-ref-primary-primary-50', className)}
      xmlns="http://www.w3.org/2000/svg"
      width="160"
      height="167"
      viewBox="0 0 160 167"
      {...restProps}
      fill="none"
    >
      <title>{title}</title>
      <g clipPath="url(#clip0_11752_1485)">
        <path
          d="M80.0034 47.0954C104.727 47.0954 124.777 26.3513 124.777 0.758789H35.2295C35.2295 26.3513 55.2721 47.0954 80.0034 47.0954Z"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M80.0041 166.241C123.771 166.241 159.25 129.525 159.25 84.2358H0.757812C0.757812 129.525 36.2376 166.241 80.0041 166.241Z"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M79.5812 127.523C67.9692 122.955 56.4996 116.453 48.8644 109.222C39.6081 100.451 34.7148 90.6552 34.7148 80.8977V34.5004L80.1175 14.6592L125.278 34.4321V80.9053C125.278 90.6628 120.384 100.458 111.128 109.229C103.493 116.46 92.896 122.955 81.284 127.523L80.419 127.978L79.5812 127.523Z"
          fill="#5580F6"
        />
        <path
          d="M80.0038 91.8084C91.4287 91.8084 100.69 82.5312 100.69 71.0871C100.69 59.643 91.4287 50.3657 80.0038 50.3657C68.579 50.3657 59.3174 59.643 59.3174 71.0871C59.3174 82.5312 68.579 91.8084 80.0038 91.8084Z"
          fill="white"
        />
        <path
          d="M69.9297 71.8381L77.1256 79.0462L90.0708 63.1201"
          stroke="black"
          strokeWidth="1.80827"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_11752_1485">
          <rect width="160" height="167" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

DisputeSubmittedIllustration.displayName = 'DisputeSubmittedIllustration';
